<template>
  <!-- OCR読み取りファイル一覧 -->
  <ModalDialog
    pop-name="OCR読み取りファイル一覧"
    dialog-width="650px"
    dialog-height="auto"
    margin-class="mbm-3"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="mtp-3">
        <div>
          <div>読み取り完了ファイル一覧</div>
          <div v-for="item in options" :key="item.jobId">
            <div class="d-flex justify-content-between">
              <b
                ><a
                  class="link"
                  style="cursor: pointer; margin-left: 14px"
                  @click="openModalAllIn(item.jobId)"
                  >{{ item.gemponFileName }}</a
                ></b
              >
              <div>{{ item.startDate }}</div>
            </div>
          </div>
        </div>
        <div class="mtp-3">
          <div>読み取り中ファイル一覧</div>
          <div v-for="item in optionsRead" :key="item.jobId">
            <div class="d-flex justify-content-between">
              <div style="margin-left: 14px">{{ item.gemponFileName }}</div>
              <div>{{ item.startDate }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer> </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'ListOfOCRReadFilesDialog',
  props: {
    options: Array,
    optionsRead: Array
  },
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    openModalAllIn(jobId) {
      this.$emit('to', jobId)
    }
  }
}
</script>
<style scoped lang="scss"></style>
